import type { C1_EloItem_Definition } from "../types/C1_EloTypes";

/** Furniture-controlled containers are available only through the furniture option. */
export function availableFurnitureEloDefinitions(
  definitions: C1_EloItem_Definition[],
  properties: Record<string, unknown> = {},
  wallDocked = false,
): C1_EloItem_Definition[] {
  return definitions
    .filter(definition => !definition.requiresFurnitureProperty || properties[definition.requiresFurnitureProperty] === true)
    .filter(definition => !definition.onlyIfWallDocked || wallDocked)
    .map(definition => definition.items
      ? { ...definition, items: availableFurnitureEloDefinitions(definition.items, properties, wallDocked) }
      : definition);
}
